import {
  getCourses,
  duplicateCourse,
  deleteCourse,
  findStudentsByCourse,
  setLiveCourse,
} from '@/api/school';

const initialState = () => ({
  courses: [],
  students: [],
});

export default {
  namespaced: true,
  state: initialState(),
  mutations: {
    setCourses(state, { data }) {
      state.courses = data;
    },
    setStudents(state, { data }) {
      state.students = data;
    },
    removeCourse(state, id) {
      state.courses = state.courses.filter(course => course.id !== id);
    },
    removeStudent(state, id) {
      state.students = state.students.filter(student => student.id !== id);
    },
    pasteCourse(state, { data }) {
      state.courses.unshift(data);
    },
    setLiveCourse(state, courseId) {
      state.courses = state.courses
        .map(course => Object.assign(course, { live: course.id === courseId }));
    },
    setHomepageCourse(state, courseId) {
      state.courses = state.courses
        .map(course => Object.assign(course, { homepage: course.id === courseId }));
    },
    reset(state) {
      Object.assign(state, initialState());
    },
  },
  actions: {
    async getCourses({ commit }) {
      commit('setCourses', await getCourses());
    },
    async duplicateCourse({ commit }, courseId) {
      commit('pasteCourse', await duplicateCourse(courseId));
    },
    async deleteCourse({ commit }, courseId) {
      await deleteCourse(courseId);
      commit('removeCourse', courseId);
    },
    async findStudentsByCourse({ commit }, courseId) {
      if (!courseId) return;
      commit('setStudents', await findStudentsByCourse(courseId));
    },
    async setLiveCourse({ commit }, courseId) {
      await setLiveCourse(courseId);
      commit('setLiveCourse', courseId);
    },
  },
  getters: {
    courses: state => state.courses,
    course: state => id => state.courses.find(course => course.id === id),
    students: state => state.students,
  },
};
